import type {
  FocusEventHandler,
  ChangeEventHandler,
  MouseEventHandler,
} from "react";
import { useRef, useEffect } from "react";
import CHECKBOX_TRUE_VALUE from "~/constants/form/CHECKBOX_TRUE_VALUE";
import className from "~/kernel/styling/className";

type CheckboxFieldProps = {
  indeterminate?: boolean;
  id: string;
  name?: string;
  defaultChecked?: boolean;
  checked?: boolean;
  required?: boolean;
  disabled?: boolean;
  tabIndex?: number;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onBlur?: FocusEventHandler;
  onClick?: MouseEventHandler;
  readOnly?: boolean;
  value?: string;
  "aria-label"?: string;
};

export function CheckboxField({
  indeterminate = false,
  required,
  id,
  name = id,
  defaultChecked,
  disabled,
  tabIndex,
  onChange,
  onClick,
  readOnly,
  checked,
  "aria-label": ariaLabel,
  value = CHECKBOX_TRUE_VALUE,
}: CheckboxFieldProps) {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  return (
    <input
      ref={ref}
      type="checkbox"
      className={className("checkbox", { "read-only": readOnly })}
      defaultChecked={defaultChecked}
      required={required}
      checked={checked}
      id={id}
      name={name}
      value={value}
      disabled={disabled}
      tabIndex={tabIndex}
      onChange={onChange}
      onClick={onClick}
      readOnly={readOnly}
      aria-label={ariaLabel}
    />
  );
}
